import type { Locale } from './core.js';
import { de, type Messages } from './locales/de.js';
import { en } from './locales/en.js';
import { pl } from './locales/pl.js';

export * from './core.js';
export type { Messages };

const MESSAGES: Record<Locale, Messages> = { de, en, pl };

/** All texts of a language; every language has the full set (enforced by `Messages`). */
export const messagesFor = (locale: Locale): Messages => MESSAGES[locale];
